module.exports = __webpack_public_path__ + "images/embed/clear_search.gif";